export default __webpack_public_path__ + "816b49a2709d976677040fffec127ace.webp";